
import { AppNavComponent } from './nav.component';
import { AppRootService } from '../../services/app-root/app-root-service';
import { CardModule } from 'libraries/ui_card/card.module';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TabNavigationModule } from 'libraries/component/tab-navigation/tab-navigation.module';
import { UIModule } from 'libraries/ui/ui.module';
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";

@NgModule({
    imports: [
        CardModule,
        CommonModule,
        FontAwesomeModule,
        RouterModule,
        TabNavigationModule,
        UIModule,
        IconNameToDefinitionModule,
        // ConfigurationResourceModule,
    ],
    exports: [
        AppNavComponent,
    ],
    declarations: [
        AppNavComponent,
    ],
    providers: [
        // AppRootService,
    ],
})
export class AppNavModule {}
